import axios from 'axios'
const SongApi = {
    async getSong(id) {
       const song = await axios.get('/api/_song')
       return song
    }
}

export default SongApi